export default __webpack_public_path__ + "img/hp-sowe.13690f28.png";